import { notification } from "antd";
import { NotificationInstance } from "antd/es/notification/interface";
import { FC, createContext, useContext } from "react";

export const NotificationContext = createContext<NotificationInstance | null>(null);

export const NotificationProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notificationApi, contextHolder] = notification.useNotification({ maxCount: 1 });
  return (
    <NotificationContext.Provider value={notificationApi}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export function useNotify() {
  const notificationApi = useContext(NotificationContext);
  if (!notificationApi) {
    throw new Error("useNotify must be used within NotificationProvider");
  }
  return notificationApi;
}
